import {combineReducers} from "redux";
import orderReducer from "@App/state/reducers/orderReducer";
import filterReducer from "@App/state/reducers/filterReducer";
import authReducer from "@App/state/reducers/authReducer";

const reducers = combineReducers({
    orders: orderReducer,
    filters: filterReducer,
    auth: authReducer,
})

export default reducers

// compile all reducers to a single state that we can use in hooks
export type State = ReturnType<typeof reducers>
